import { AxiosResponse } from "axios";
import { axiosInstance, MessageResponse } from "src/api/common";

export enum ReviewStatusEnum {
    APPROVED = "APPROVED",
    SKIPPED = "SKIPPED",
    ASSIGNED = "ASSIGNED",
}

export interface ReviewStatus {
    status: ReviewStatusEnum | null;
    assigned_by?: string | null;
    assigned_at?: string | null;
    approver?: string | null;
    approved_at?: string | null;
    skipped_by?: string | null;
    skipped_at?: string | null;
    comment?: string | null;
}

export enum UserActionType {
    IR_L1_REVIEW = "IR_L1_REVIEW",
    IR_L2_REVIEW = "IR_L2_REVIEW",
    IR_L3_REVIEW = "IR_L3_REVIEW"
}

export interface ReportReviewPayload {
    action_type: UserActionType;
    review_status: ReviewStatus;
}

export type UserActionsStatusResponse = {
    ir_l1_review?: ReviewStatus | null;
    ir_l2_review?: ReviewStatus | null;
    ir_l3_review?: ReviewStatus | null;
};

const UserActionStatusAPI = {
    get_user_actions_status: async ({ case_id }: { case_id: string }): Promise<UserActionsStatusResponse> => {
        const response: AxiosResponse<UserActionsStatusResponse> = await axiosInstance.get(
            `v1/cases/${case_id}/user-actions-status`
        );
        return response.data;
    },

    put_ir_review_status: async ({ case_id, action_type, request }: { case_id: string; action_type: UserActionType; request: ReviewStatus }): Promise<MessageResponse> => {
        const response: AxiosResponse<MessageResponse> = await axiosInstance.put(
            `v1/cases/${case_id}/user-actions-status/ir-review/${action_type}`,
            request
        );
        return response.data;
    },
}

export default UserActionStatusAPI;